import NavLink from 'react-router-dom/NavLink';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const Product = styled(NavLink)`
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 10px;
  text-decoration: none;
  font-family: ${theme('fonts.base')};
  color: #fff;
  background: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export default Product;
